import universeJSON from './universe.json';
import systemsJSON from './systems/index';
universeJSON.systems= systemsJSON;

export default universeJSON;